module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('api-table-block', {
    ref: "registrationTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.loadHourRegistrations,
      "default-sort-by": "placed_at",
      "item-label-singular": "urenregistratie",
      "item-label-plural": "Urenregistraties",
      "hideSearchBar": true
    },
    scopedSlots: _vm._u([{
      key: "created_at",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("capitalize")(_vm._f("moment")(data.value, 'calendar'))) + "\n    ")]
      }
    }, {
      key: "display_start",
      fn: function(data) {
        return [(data.item.editing) ? _c('span', [_c('b-input', {
          model: {
            value: (data.item.temp['display_start']),
            callback: function($$v) {
              _vm.$set(data.item.temp, 'display_start', $$v)
            },
            expression: "data.item.temp['display_start']"
          }
        })], 1) : _c('span', [_vm._v("\n        " + _vm._s(data.value) + "\n      ")])]
      }
    }, {
      key: "display_stop",
      fn: function(data) {
        return [(data.item.editing) ? _c('span', [_c('b-input', {
          model: {
            value: (data.item.temp['display_stop']),
            callback: function($$v) {
              _vm.$set(data.item.temp, 'display_stop', $$v)
            },
            expression: "data.item.temp['display_stop']"
          }
        })], 1) : _c('span', [_vm._v("\n        " + _vm._s(data.value) + "\n      ")])]
      }
    }, {
      key: "hours_worked",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value) + "\n    ")]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [(!data.item.editing) ? _c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.deleteEntry(data.item.id)
            }
          }
        }, [_vm._v("Verwijderen")]), _vm._v(" "), (_vm.role === 'admin') ? _c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.doEdit(data.item)
            }
          }
        }, [_vm._v("Edit")]) : _vm._e()]) : _c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.doCancel(data.item)
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.doSave(data.item)
            }
          }
        }, [_vm._v("Save")])])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-031427ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/employees/HourRegistrationTable.vue
// module id = 686
// module chunks = 1